export const tableColumnsManagement = [
    {
        Header: "User",
        accessor: "userOnly",       // new column for user
    },
    {
        Header: "Category",
        accessor: "categoryOnly",   // use the split category
    },
    {
        Header: 'Sub Category',
        accessor: 'subCategory',
    },
    {
        Header: 'App Version',
        accessor: 'appVer',
    },
    {
        Header: 'Product Name',
        accessor: 'productId',
    },
    {
        Header: 'Device Address',
        accessor: 'deviceAddress',
    },
    {
        Header: 'Feedback',
        accessor: 'feedback',
    },
    {
        Header: 'Status',
        accessor: 'status',
    },
    {
        Header: 'Created Time',
        accessor: 'createdTime',
    },
    {
        Header: 'Last Updated',
        accessor: 'lastModified',
    },
    /*  {
        Header: '',
        accessor: 'button',
      },*/
];
